export const ENDPOINTS = {
  admin: {
    list_resources: (stage: string | number) => `admin/cms/resource/list/${stage}`,
    detail_resource: (resource: string | number) => `admin/cms/resource/details/${resource}`,
  },
  non_admin: {
    list_resources: (stage: string | number) => `cms/resource/list/${stage}`,
  },
};
